import { CaseData } from "@/cms/models";
import { getCaseClassification, isLand } from "@/utils/helper";
import PlotOfLandPropertyFacts from "./PlotOfLandPropertyFacts";
import DefaultPropertyFacts from "./DefaultPropertyFacts";

const PropertyFacts: React.FC<{
  caseData: CaseData;
}> = ({ caseData }) => {
  const classifications = getCaseClassification(caseData);
  return isLand(classifications) ? (
    <PlotOfLandPropertyFacts caseData={caseData} />
  ) : (
    <DefaultPropertyFacts caseData={caseData} />
  );
};

export default PropertyFacts;
